import { useSearchParams } from 'react-router-dom';
import { useShowsBeta } from '~/beta/betaHooks';
import Loadable from '~/components/LoadableErrorReload';
import { usePayoutDetailsV2Flag } from '~/hooks/usePayoutDetailsV2Flag';

import { isPayoutDetailsV2View } from './payoutDetailsV2View';

const PayoutDetails = Loadable(() => import('./details'));
const PayoutDetailsV2 = Loadable(() => import('./details-v2/page'));

const PayoutDetailsRoute = () => {
  const { isPayoutDetailsV2Enabled } = usePayoutDetailsV2Flag();
  const [searchParams] = useSearchParams();
  const showsBeta = useShowsBeta('payoutDetails');

  return showsBeta || (isPayoutDetailsV2Enabled && isPayoutDetailsV2View(searchParams)) ? (
    <PayoutDetailsV2 />
  ) : (
    <PayoutDetails />
  );
};

export default PayoutDetailsRoute;
